<div class="content p-24">

    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="h2 mb-24">{{'Customer data'|translate}}</div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'First name'|translate}}</mat-label>
                    <input matInput formControlName="firstName" required (input)="checkIfCustomerExistsByName()">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>{{'First Name is required!'|translate}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>{{'Last name'|translate}}</mat-label>
                    <input matInput formControlName="lastName" required (input)="checkIfCustomerExistsByName()">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>{{'Last Name is required!'|translate}}</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="(vouchers.length > 0) || (user && vouchers.length > 0)">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Card number'|translate}}</mat-label>
                    <input matInput formControlName="cardNumber" (input)="verifyCardNumber($event)">
                    <div style="color: red;" *ngIf="!checkingCardNumber && cardExists">{{'Card already assigned to other customer!'|translate}}</div>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50">
                    <mat-label>{{'Voucher'|translate}}</mat-label>
                    <mat-select formControlName="openDayVoucherId">
                        <mat-option [value]="voucher.id" *ngFor="let voucher of vouchers">
                            {{voucher.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>{{'E - mail'|translate}}</mat-label>
                    <input matInput formControlName="email" required>
                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                    <mat-error>{{'E - mail is required!'|translate}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>{{'Phone'|translate}}</mat-label>
                    <input matInput formControlName="phone">
                    <mat-icon matSuffix class="secondary-text">phone_iphone</mat-icon>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Street'|translate}}</mat-label>
                    <input matInput formControlName="street">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="25" class="pl-4">
                    <mat-label>{{'House number'|translate}}</mat-label>
                    <input matInput formControlName="houseNumber">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="25" class="pl-4">
                    <mat-label>{{'Flat number'|translate}}</mat-label>
                    <input matInput formControlName="flatNumber">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="20" class="pr-4">
                    <mat-label>{{'Post code'|translate}}</mat-label>
                    <input matInput formControlName="postCode">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="40" class="pl-4">
                    <mat-label>{{'City'|translate}}</mat-label>
                    <input matInput formControlName="city">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="40">
                        <mat-label>{{'Country'|translate}}</mat-label>
                        <mat-select formControlName="country">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="countryFilterCtrl" placeholderLabel="{{'Search...'|translate}}" noEntriesFoundLabel="No countries found"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option [value]="country.id" *ngFor="let country of filteredCountries | async">
                                {{country.name|translate}}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                        <mat-error>Country is required!</mat-error>
                    </mat-form-field>
                </div>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Customer description'|translate}}</mat-label>
                    <textarea matInput formControlName="description" class="textarea" style="width: 100%;" rows="5"></textarea>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <h2>{{'Company data'|translate}}</h2>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'NIP'|translate}}</mat-label>
                    <input matInput formControlName="nip">
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Name'|translate}}</mat-label>
                    <input matInput formControlName="companyName">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Street'|translate}}</mat-label>
                    <input matInput formControlName="companyStreet">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="20" class="pr-4">
                    <mat-label>{{'Post code'|translate}}</mat-label>
                    <input matInput formControlName="companyPostCode">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="40" class="pl-4">
                    <mat-label>{{'City'|translate}}</mat-label>
                    <input matInput formControlName="companyCity">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="40">
                        <mat-label>{{'Country'|translate}}</mat-label>
                        <mat-select formControlName="companyCountry">
                            <mat-option>
                                <ngx-mat-select-search [formControl]="companyCountryFilterCtrl" placeholderLabel="{{'Search...'|translate}}" noEntriesFoundLabel="No countries found"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option [value]="country.id" *ngFor="let country of filteredCompanyCountries | async">
                                {{country.name|translate}}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                    </mat-form-field>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Sex'|translate}}</mat-label>
                    <mat-select formControlName="sex">
                        <mat-option [value]="'female'">
                            {{'Female'|translate}}
                        </mat-option>
                        <mat-option [value]="'male'">
                            {{'Male'|translate}}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                </mat-form-field>


            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="20">
                    <mat-label>{{'Birth day'|translate}}</mat-label>
                    <mat-select formControlName="birthdayDay" required>
                        <mat-option [value]="birthDay" *ngFor="let birthDay of birthDays">
                            {{birthDay}}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                    <mat-error>{{'Day of birthday is required!'|translate}}</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="50">
                    <mat-label>{{'Birth month'|translate}}</mat-label>
                    <mat-select formControlName="birthdayMonth" required>
                        <mat-option [value]="birthMonth.id" *ngFor="let birthMonth of birthMonths">
                            {{ birthMonth.name|translate }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                    <mat-error>{{'Month of birthday is required!'|translate}}</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="30">
                    <mat-label>{{'Birth year'|translate}}</mat-label>
                    <mat-select formControlName="birthdayYear" required>
                        <mat-option [value]="birthYear" *ngFor="let birthYear of birthYears">
                            {{ birthYear }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                    <mat-error>{{'Year of birthday is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Customer source'|translate}}</mat-label>
                    <mat-select formControlName="clientSource" required>
                        <mat-option [value]="customerSource.id" *ngFor="let customerSource of customerSources">
                            {{customerSource.name}}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                    <mat-error>{{'Customer source is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="readTheContraindications" fxFlex="100">
                    <mat-label>{{'Familiarized himself with the contraindications'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="readTheRegulations" fxFlex="100">
                    <mat-label>{{'Read the regulations'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="readThePriceList" fxFlex="100">
                    <mat-label>{{'Read the price list'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="consentToMarketing" fxFlex="100">
                    <mat-label>{{'Consent to marketing'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="gdprAgrees" fxFlex="100">
                    <mat-label>{{'GDPR agrees'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="multiSport" fxFlex="100">
                    <mat-label>{{'Multi Sport'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="medicover" fxFlex="100">
                    <mat-label>{{'Medicover'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="medicoverPlus" fxFlex="100">
                    <mat-label>{{'Medicover Plus'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="profit" fxFlex="100">
                    <mat-label>{{'ProFit'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="pzuSport" fxFlex="100">
                    <mat-label>{{'PZU Sport'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <input type="file" multiple (change)="onDocumentsChange($event)"/>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="user && user.documents">
                <table class="table table-hover" style="width: 100%;">
                    <thead>
                    <tr>
                        <th>Nazwa pliku</th>
                        <th>Rozmiar</th>
                        <th>Data dodania</th>
                        <th>Dodał</th>
                        <th>Akcje</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let document of user.documents">
                        <td>{{document.originalName}}</td>
                        <td style="text-align: right;">{{(document.size/(1024))| number:'1.0-0'}} kb</td>
                        <td>{{document.createdAt|date: 'd.MM.y H:mm:ss': 'UTC+2': 'pl'}}</td>
                        <td>{{document.createdBy?.firstName}} {{document.createdBy?.lastName}} ({{document.createdBy?.username}})</td>
                        <td>
                            <a *ngIf="!document.downloading" style="cursor: pointer;" (click)="downloadFile(document)">Pobierz</a>
                            <span *ngIf="document.downloading">
                                <mat-spinner [diameter]="20"></mat-spinner> Pobieram...
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div fxLayout="row" fxLayoutAlign="end center" fxFlex="1 0 auto">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button type="submit" color="accent" *ngIf="!checkingCardNumber && !cardExists && !submitted">
                        {{'Save'|translate}}
                    </button>
                    <button mat-raised-button type="submit"  disabled *ngIf="checkingCardNumber || cardExists || submitted">
                        <mat-spinner [diameter]="20"></mat-spinner>
                        {{'Saving'|translate}}...
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
